import { reactive } from "vue";

// 定义事件处理器类型
type EventHandler = (...args: any[]) => void;

// 使用 Vue 3 的响应式 API 创建事件总线
const eventBus = reactive<{
  events: Record<string, EventHandler[]>;
  on: (event: string, handler: EventHandler) => void;
  off: (event: string, handler: EventHandler) => void;
  emit: (event: string, ...args: any[]) => void;
  clear: () => void;
}>({
  events: {},

  // 监听事件
  on(event: string, handler: EventHandler) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    const handlers = this.events[event];
    if (handlers) {
      handlers.push(handler);
    }
  },

  // 取消监听
  off(event: string, handler: EventHandler) {
    const handlers = this.events[event];
    if (handlers && handlers.length > 0) {
      const index = handlers.indexOf(handler);
      if (index > -1) {
        handlers.splice(index, 1);
      }
    }
  },

  // 触发事件
  emit(event: string, ...args: any[]) {
    const handlers = this.events[event];
    if (handlers) {
      handlers.forEach((handler) => handler(...args));
    }
  },

  // 清除所有监听
  clear() {
    this.events = {};
  },
});

export default eventBus;
